import { render, staticRenderFns } from "./CmpRlbTable.vue?vue&type=template&id=8747d964&"
import script from "./CmpRlbTable.vue?vue&type=script&lang=js&"
export * from "./CmpRlbTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports